import { createSlice } from "@reduxjs/toolkit";
import { withAccessToken } from "../../server/api";
import { Chat } from "../api/chatApi";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_FINAN_DOMAIN;

const initialState = {
  orders: [],
  productItem: [],
  orders_meta: {
    page: 1,
    page_size: 0,
    total_pages: 1,
    total_rows: 0,
  },
};

const getOrderItemFromOrders = (payload) => {
  return payload.reduce((arr, item) => {
    let obj = {
      order_number: item.order_number,
      grand_total: item.grand_total || 0,
      state: item.state,
      ...item,
    };
    arr.push(obj);
    return arr;
  }, []);
};

const slice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    hasDone(state, action) {
      state.isLoading = false;
    },

    getOrderSuccess(state, action) {
      const { payload } = action;
      state.orders = getOrderItemFromOrders(payload.orders);
      state.orders_meta = payload.orders_meta;
    },

    getProductSuccess(state, action) {
      const { payload } = action;
      state.productItem = payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

const getProductItemFromProduct = (payload) => {
  return payload.reduce((arr, item) => {
    let obj = {
      ...item.order_item.slice(0, 1)[0],
      order_number: item.order_number,
      ordered_grand_total: item.ordered_grand_total || 0,
      grand_total: item.grand_total,
      state: item.state,
    };
    arr.push(obj);
    return arr;
  }, []);
};

export function getOrders(params) {
  const { userId, userChatId, business_id } = params;
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });
      const response = await Chat.getOrders({
        params: {
          seller_id: userChatId,
          buyer_id: userId,
          business_id,
        },
        headers: config,
      });
      const orders = response?.data ?? [];
      const orders_meta = response?.meta ?? initialState.orders_meta;
      dispatch(
        slice.actions.getOrderSuccess({
          orders,
          orders_meta,
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getProducts(params) {
  const { business_id, is_active } = params;
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });
      const response = await Chat.getProducts({
        params: { business_id, is_active },
        headers: config,
      });
      const products = response?.data ?? [];
      dispatch(slice.actions.getProductSuccess(products ?? []));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getProductsLoadMore(products) {
  return (dispatch) => {
    dispatch(slice.actions.getProductSuccess(products));
  };
}

export function getOrdersLoadMore(orders) {
  return (dispatch) => {
    dispatch(slice.actions.getOrderSuccess(orders));
  };
}
